import { StatusTone } from '@/components/ui/statusTone.ts';
import { EnumTableConfig } from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import { toneEnumConfig } from '@/components/table/_fieldDefinitions/enum/enumToneConfig.ts';
import { ParticipantStatus } from '@/features/dashboard/participants/types/ParticipantStatus.ts';

export const PARTICIPANT_STATUS_LABELS: Record<ParticipantStatus, string> = {
  [ParticipantStatus.ACTIVE]: 'Aktywny',
  [ParticipantStatus.WITHDRAWN]: 'Rezygnacja',
};

export const getParticipantStatusLabel = (status: ParticipantStatus): string =>
  PARTICIPANT_STATUS_LABELS[status];

export const PARTICIPANT_STATUS_TONE: Record<ParticipantStatus, StatusTone> = {
  [ParticipantStatus.ACTIVE]: 'success',
  [ParticipantStatus.WITHDRAWN]: 'neutral',
};

export const participantStatusTableConfig: EnumTableConfig = Object.fromEntries(
  Object.values(ParticipantStatus).map((status) => [
    status,
    toneEnumConfig(
      PARTICIPANT_STATUS_LABELS[status],
      PARTICIPANT_STATUS_TONE[status],
    ),
  ]),
);
